import React from "react";
import { useSelector } from "react-redux";
import { isAuthorized } from "../../_helpers";
import PropTypes from "prop-types";

export const AuthorizedWrapper = ({ authorizedRoles, children }) => {
  const user = useSelector((state) => state.users.user);
  return user &&
    isAuthorized([user.role], authorizedRoles) &&
    React.isValidElement(children)
    ? children
    : null;
};

AuthorizedWrapper.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.element,
};
